<script lang="ts">
    import {CollapsedIcon, ExpandedIcon, LayersIcon} from "@anyways-open/common-svgs"

    export let visible: boolean = true;
    export let canRemove: boolean = false;
    export let expanded: boolean = false;
    export let canExpand: boolean = true;
    export let canSave: boolean = false;
    export let canVisible: boolean = true;
</script>

<div class="row py-1 gx-0">
    <div class="container px-0">
        <div class="row gx-0">
            <div class="d-flex">
                <div
                    class="btn pe-1 p-0 layer-toggle-icon {canExpand
                        ? ''
                        : 'disabled'}"
                    on:click={() => (expanded = !expanded)}>
                    {#if expanded}
                        <ExpandedIcon />
                    {:else}
                        <CollapsedIcon />
                    {/if}
                </div>
                <div class="svg-icon-sm pe-1">
                    <slot name="icon">
                        <LayersIcon />
                    </slot>
                </div>
                <div class="layer-title w-100">
                    <h5>
                        <slot name="title">
                            <span>Empty</span>
                        </slot>
                    </h5>
                </div>
                {#if canSave}
                    <div
                        class="btn badge badge-rounded-circle badge-success-soft ms-auto">
                        <i class="fe fe-edit" />
                    </div>
                    <div
                        class="btn badge badge-rounded-circle badge-success-soft ms-1">
                        <i class="fe fe-save" />
                    </div>
                {/if}
                {#if canVisible}
                    <div
                        class="btn badge badge-rounded-circle badge-success-soft {canSave
                            ? 'ms-1'
                            : 'ms-auto'} "
                        on:click={() => {
                            visible = !visible;
                        }}>
                        {#if visible}
                            <i class="fe fe-eye" />
                        {:else}
                            <i class="fe fe-eye-off" />
                        {/if}
                    </div>
                {/if}
                {#if canRemove}
                    <div
                        class="btn badge badge-rounded-circle badge-success-soft ms-1 {canRemove
                            ? ''
                            : 'disabled'}">
                        <i class="fe fe-trash-2" />
                    </div>
                {/if}
            </div>
        </div>
        {#if expanded}
            <div class="row gx-0">
                <slot name="content">Content here!</slot>
            </div>
        {/if}
    </div>
</div>

<style>
    .badge {
        margin-top: 2px;
        font-size: 12.75px;
    }
</style>
